export interface ChangePassword {
  employeeId?: string;
  newPasswordA: string;
  newPasswordB: string;
  oldPassword: string;
  representativeId: number;
}
